import "./sentry";
import { ThemeProvider } from "@mui/styles";
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { StateProvider } from "./globalstore";
import "./index.css";
import { theme } from "./theme";
import { ensureLatestVersion } from "./lib/appVersion";

import { createRoot } from "react-dom/client";

ensureLatestVersion();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
		<ErrorBoundary>
			<Router>
				<StateProvider>
					<ThemeProvider theme={theme}>
						<App />
					</ThemeProvider>
				</StateProvider>
			</Router>
		</ErrorBoundary>
);
